/**
 * Single data-access point for the whole site.
 *
 * Today it reads static JSON from `public/data/<resource>.json`, which behaves
 * exactly like a REST API (real network fetch, async, can fail). When the real
 * backend is ready you do NOT touch any component — just set one env var:
 *
 *   REACT_APP_API_URL=https://api.kcgs-kccwc.edu.bd/v1
 *
 * and every `fetchResource("slides")` call starts hitting `${API_BASE}/slides`
 * instead of `/data/slides.json`. Keep the API's JSON shape identical to the
 * files in `public/data/` (or adapt it here in one place).
 */

const API_BASE = process.env.REACT_APP_API_URL || "";
const LOCAL_BASE = `${process.env.PUBLIC_URL || ""}/data`;

export function resourceUrl(resource) {
  return API_BASE ? `${API_BASE}/${resource}` : `${LOCAL_BASE}/${resource}.json`;
}

export async function fetchResource(resource, { signal } = {}) {
  const res = await fetch(resourceUrl(resource), {
    signal,
    headers: { Accept: "application/json" },
  });
  if (!res.ok) {
    throw new Error(`Failed to load "${resource}" (HTTP ${res.status})`);
  }
  return res.json();
}
